import React from "react";
import Header from "../header/Header";
import Copyrights from "../copyrights/Copyrights";
import "./Layout.scss";

interface LayoutProps {
  children: React.ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  showHeader = true,
  showFooter = true,
}) => {
  return (
    <div className="layout">
      {showHeader && <Header />}
      <main className="layout__content">{children}</main>
      {showFooter && <Copyrights />}
    </div>
  );
};

export default Layout;

